import React, { useState, useRef, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import * as QueryString from 'query-string';
import ClaimList from '@components/shared/claim/ClaimList';
import SearchBar from '@components/util/SearchBar';
import { Breadcrumb, Card, Col, Row } from 'react-bootstrap';
import claimService from '@services/claim/claim.service';
import { useDispatch } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import MasterSidebar from '@rd-web-markets/shared/dist/util/MasterSidebar';
import ClaimGroupsListNavigation from '@rd-web-markets/market/dist/claim_group/list/ClaimGroupsListNavigation';
import Pagination from '@rd-web-markets/shared/dist/util/Pagination';
import { USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';
import ClaimsTopLevelNavigation from './v2/ClaimsTopLevelNavigation';

const initialParams = {
  type: 'active',
  order_by: 'companies.name asc, to_date desc',
  page: 1,
  query: ''
}

const AllClaimsPage = ({ accountType }) => {
  const [claims, setClaims] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const history = useHistory();
  const [params, setParams] = useState(
    window.location.search ? QueryString.parse(window.location.search) : initialParams
  );

  useEffect(() => {
    setLoading(true);
    fetch(`/api/claims?${QueryString.stringify(params)}`, { method: 'GET' })
      .then((response) => {
        setClaims(response.claims);
        setTotalPages(response.pages);
        setLoading(false);
        history.push({
          path: 'admin/claims',
          search: QueryString.stringify(params),
        });
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, [history, params]);

  const handleSearch = (query) => {
    setParams({ ...params, query, page: 1 });
  };

  const handlePage = (pageNumber) => {
    window.scrollTo(0, 0);
    setParams({ ...params, page: pageNumber });
  };

  const handleDeleteClaim = async id => {
    if(window.confirm('Are you sure you wish to delete this claim ?')){
      setLoading(true);
      try {
        await claimService.deleteClaim(id);
        setClaims(claims.filter(claim => claim.id !== id));
      } catch(error) {
        dispatch(handleError(error));
      }
      setLoading(false);
    }
  }

  return (
    <>
      {!USE_V2_DESIGN && <MasterSidebar accountType={accountType} currentPage='all_claim_groups' />}
      {!USE_V2_DESIGN && (
        <BreadcrumbsPortal>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: '/admin'}}>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>All Claims</Breadcrumb.Item>
          </Breadcrumb>
        </BreadcrumbsPortal>
      )}
      

      <Row className={USE_V2_DESIGN ? 'justify-content-center mx-0 mt-4' : ''}>
        <Col md={USE_V2_DESIGN ? 10 : 12}>
          {USE_V2_DESIGN && <h1 className='fw-bold mb-3' style={{ color: '#0078B9' }}>All Claims</h1>}
          { USE_V2_DESIGN && <ClaimsTopLevelNavigation accountType={accountType} /> }

          <Card>
            <Card.Header>
              <ClaimGroupsListNavigation page='claims' />
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={12}>
                  <Card>
                    <Card.Header>
                      <Row>
                        <Col md={1}>All Claims</Col>
                        <Col md={{ span: 4, offset: 7 }}>
                          <SearchBar onSubmit={handleSearch} loading={loading} query={params.query} />
                        </Col>
                      </Row>
                    </Card.Header>
                    <Card.Body>
                      {claims && <ClaimList claims={claims} handleDeleteClaim={handleDeleteClaim} loading={loading} role={'admin'}/>}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Pagination currentPage={Number(params.page)} totalPages={totalPages} handlePageChange={handlePage} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default AllClaimsPage
